"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Desktop.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Desktop = function Desktop(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 196.8 128.11"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Desktop Icon"), _react2.default.createElement("g", {
    className: "desktop",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    d: "M31.22 112.67h137.72a15.41 15.41 0 0 0 15.4-15.4V15.4A15.42 15.42 0 0 0 168.94 0H31.22a15.42 15.42 0 0 0-15.4 15.4v81.85a15.41 15.41 0 0 0 15.4 15.42zM22.76 15.4a8.46 8.46 0 0 1 8.45-8.45h137.73a8.46 8.46 0 0 1 8.45 8.45v81.85a8.46 8.46 0 0 1-8.45 8.45H31.22a8.46 8.46 0 0 1-8.46-8.45V15.4z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M32.98 44.781l38.399-26.047 3.896 5.743-38.4 26.047zm-4.625 22.587l69.78-47.085 3.882 5.753-69.78 47.085zM193.88 114.6h-191a2.93 2.93 0 0 0-2.92 2.92v7.67a2.93 2.93 0 0 0 2.92 2.92h191a2.93 2.93 0 0 0 2.92-2.92v-7.67a2.93 2.93 0 0 0-2.92-2.92zm-86.22 10a1.6 1.6 0 0 1-1.59 1.59H84.94a1.6 1.6 0 0 1-1.59-1.59v-5.31a1.59 1.59 0 0 1 1.59-1.59h21.13a1.59 1.59 0 0 1 1.59 1.59v5.31z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8
    },
    __self: undefined
  })));
};
exports.default = Desktop;